import { window } from './facade/browser';
export function isBs3() {
    return window.__theme !== 'bs4';
}
//# sourceMappingURL=ng2-bootstrap-config.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng2-bootstrap/utils/ng2-bootstrap-config.js
// module id = 52
// module chunks = 16